/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetSupportedAccountEntitlementsLogsActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedAccountEntitlementsLogsActionsRequest = createAction<PayloadData<void>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_ACCOUNT_ENTITLEMENTS_LOGS_ACTIONS__REQUEST');
export const getSupportedAccountEntitlementsLogsActionsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_ACCOUNT_ENTITLEMENTS_LOGS_ACTIONS__SUCCESS');
export const getSupportedAccountEntitlementsLogsActionsFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_ACCOUNT_ENTITLEMENTS_LOGS_ACTIONS__FAILURE');

export const getSupportedAccountEntitlementsLogsActionsActions = [
    getSupportedAccountEntitlementsLogsActionsRequest,
    getSupportedAccountEntitlementsLogsActionsSuccess,
    getSupportedAccountEntitlementsLogsActionsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedAccountEntitlementsLogsActions = (config?: GetSupportedAccountEntitlementsLogsActions$Config) => {
    return {
        CALL_API: {
            types: getSupportedAccountEntitlementsLogsActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/entitlements/account`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSupportedGrantEntitlementsLogsActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedGrantEntitlementsLogsActionsRequest = createAction<PayloadData<void>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_GRANT_ENTITLEMENTS_LOGS_ACTIONS__REQUEST');
export const getSupportedGrantEntitlementsLogsActionsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_GRANT_ENTITLEMENTS_LOGS_ACTIONS__SUCCESS');
export const getSupportedGrantEntitlementsLogsActionsFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_GRANT_ENTITLEMENTS_LOGS_ACTIONS__FAILURE');

export const getSupportedGrantEntitlementsLogsActionsActions = [
    getSupportedGrantEntitlementsLogsActionsRequest,
    getSupportedGrantEntitlementsLogsActionsSuccess,
    getSupportedGrantEntitlementsLogsActionsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedGrantEntitlementsLogsActions = (config?: GetSupportedGrantEntitlementsLogsActions$Config) => {
    return {
        CALL_API: {
            types: getSupportedGrantEntitlementsLogsActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/entitlements/grants`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSupportedResourceEntitlementsLogsActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedResourceEntitlementsLogsActionsRequest = createAction<PayloadData<void>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_RESOURCE_ENTITLEMENTS_LOGS_ACTIONS__REQUEST');
export const getSupportedResourceEntitlementsLogsActionsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_RESOURCE_ENTITLEMENTS_LOGS_ACTIONS__SUCCESS');
export const getSupportedResourceEntitlementsLogsActionsFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_RESOURCE_ENTITLEMENTS_LOGS_ACTIONS__FAILURE');

export const getSupportedResourceEntitlementsLogsActionsActions = [
    getSupportedResourceEntitlementsLogsActionsRequest,
    getSupportedResourceEntitlementsLogsActionsSuccess,
    getSupportedResourceEntitlementsLogsActionsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedResourceEntitlementsLogsActions = (config?: GetSupportedResourceEntitlementsLogsActions$Config) => {
    return {
        CALL_API: {
            types: getSupportedResourceEntitlementsLogsActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/entitlements/resources`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSupportedRoleEntitlementsLogsActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedRoleEntitlementsLogsActionsRequest = createAction<PayloadData<void>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_ROLE_ENTITLEMENTS_LOGS_ACTIONS__REQUEST');
export const getSupportedRoleEntitlementsLogsActionsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_ROLE_ENTITLEMENTS_LOGS_ACTIONS__SUCCESS');
export const getSupportedRoleEntitlementsLogsActionsFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_ROLE_ENTITLEMENTS_LOGS_ACTIONS__FAILURE');

export const getSupportedRoleEntitlementsLogsActionsActions = [
    getSupportedRoleEntitlementsLogsActionsRequest,
    getSupportedRoleEntitlementsLogsActionsSuccess,
    getSupportedRoleEntitlementsLogsActionsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedRoleEntitlementsLogsActions = (config?: GetSupportedRoleEntitlementsLogsActions$Config) => {
    return {
        CALL_API: {
            types: getSupportedRoleEntitlementsLogsActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/entitlements/roles`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSupportedUserEntitlementsLogsActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedUserEntitlementsLogsActionsRequest = createAction<PayloadData<void>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_USER_ENTITLEMENTS_LOGS_ACTIONS__REQUEST');
export const getSupportedUserEntitlementsLogsActionsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_USER_ENTITLEMENTS_LOGS_ACTIONS__SUCCESS');
export const getSupportedUserEntitlementsLogsActionsFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENT_LOG_DICTIONARIES__GET_SUPPORTED_USER_ENTITLEMENTS_LOGS_ACTIONS__FAILURE');

export const getSupportedUserEntitlementsLogsActionsActions = [
    getSupportedUserEntitlementsLogsActionsRequest,
    getSupportedUserEntitlementsLogsActionsSuccess,
    getSupportedUserEntitlementsLogsActionsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedUserEntitlementsLogsActions = (config?: GetSupportedUserEntitlementsLogsActions$Config) => {
    return {
        CALL_API: {
            types: getSupportedUserEntitlementsLogsActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/entitlements/users`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

